<template>
  <div class="description__ai-loading">
    <div class="description__loading-text" v-if="isAIGeneratingDescription">
      <aha-webm
        :webmSource="AITemplateDescriptionLoadingIcon"
        :content="notSupportTag"
        class="description__loading-icon"
      />
      <p>
        {{ $i18nPresenter.t('AI is generating') }}
      </p>
      <div class="description__loading-dots">
        <div class="dots-flashing"></div>
        <div class="dots-flashing"></div>
        <div class="dots-flashing"></div>
      </div>
    </div>
    <div class="description__failed-text" v-if="isAIGenerateDescriptionFailed">
      <aha-icon
        name="arrows-clock-wise"
        width="15"
        height="15"
        viewBox="0 0 16 16"
        class="mr-1"
      />
      <p>
        {{ $i18nPresenter.t('Failed to generate') }}. <span
          class="description__failed-retry"
          @click="retryGenerateTemplateDescription()"
        >{{ $i18nPresenter.t('Retry') }}</span>
      </p>
    </div>
    <div class="description__ai-close" @click="closeDescriptionArea()">
      <aha-icon
        name="close-small"
        width="15"
        height="15"
        viewBox="0 0 12 12"
      />
    </div>
  </div>
</template>

<script>
import AITemplateDescriptionLoadingIcon from '@/assets/animations/AITemplateDescriptionLoadingIcon.webm'

export default {
  props: {
    isAIGeneratingDescription: {
      type: Boolean,
      default: false,
    },
    isAIGenerateDescriptionFailed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      AITemplateDescriptionLoadingIcon,
    }
  },
  computed: {
    notSupportTag() {
      return this.$t('Your browser does not support the video tag.')
    },
  },
  methods: {
    closeDescriptionArea() {
      this.$emit('closeAIGenerateTemplateDescription')
    },
    retryGenerateTemplateDescription() {
      this.$emit('retryGenerateTemplateDescription')
    },
  },
}
</script>

<style scoped lang="scss">
.description__ai-loading {
  @apply absolute pr-6 py-3 pl-3 top-0 left-0;
  @apply border border-base-30 border-solid rounded-md;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(1px);
  background-color: rgba(255, 255, 255, 0.8);
  .description__loading-text {
    @apply font-bold text-purple-50;
    @apply flex items-center justify-center w-full h-full;
    .description__loading-icon {
      @apply w-4 mr-1;
    }
    .description__loading-dots {
      @apply flex ml-0.5 mt-1;
      .dots-flashing {
        @apply bg-purple-50 text-purple-50;
        left: 2px;
        top: 2px;
        width: 4px;
        height: 4px;
        border-radius: 5px;
        animation: dots-flashing 0.5s infinite alternate;
        &:first-child {
          animation-delay: 0s;
          margin-right: 2px;
        }
        &:nth-child(2) {
          animation-delay: 0.2s;
          margin-right: 2px;
        }
        &:last-child {
          animation-delay: 0.4s;
        }
      }

      @keyframes dots-flashing {
        0% {
          @apply bg-purple-50;
        }
        50%, 100% {
          background-color: rgba(155, 155, 155, 0.2);
        }
      }
    }
  }
  .description__failed-text {
    @apply flex items-center justify-center w-full h-full;
    .description__failed-retry {
      @apply text-base-70 hover:text-base-80 cursor-pointer underline;
    }
  }
  .description__ai-close {
    @apply text-base-60 cursor-pointer;
    @apply absolute right-2 top-1;
    @apply hover:text-base-80;
  }
}

</style>
